/* eslint-disable @typescript-eslint/no-unused-vars */
import { SternumTheme } from '@sternum/theme';
import { AvatarTheme } from '@sternum/ui';

import { Colors } from '../constants';

export function SBOMDarkAvatarTheme(theme: SternumTheme): Partial<AvatarTheme> {
  return {
    backgroundColor: Colors.PinkMiddle,
    sizes: {
      small: '28px',
      medium: '40px',
      large: '80px',
    },
  };
}
